import { isNil } from 'es-toolkit';

import { useTheme } from '@savvy/deprecated-shared/hooks/use-theme';

import type { IconColor, TextColorDefaults, WebStyle, XStyle } from './types';
import { greyIconsColor, textColors } from './theme';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents -- FIXME: This rule was recently enabled for the repo
export const mapIconColorToPalette: Record<IconColor | string, string> = {
  // TODO: Implement these colors seriously
  action: greyIconsColor,
  disabled: greyIconsColor,
  error: greyIconsColor,
  info: greyIconsColor,
  inherit: greyIconsColor,
  primary: greyIconsColor,
  secondary: greyIconsColor,
  success: greyIconsColor,
  warning: greyIconsColor,
};

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents -- FIXME: This rule was recently enabled for the repo
export const mapTextColorToPalette: Record<TextColorDefaults | string, string> = {
  textCharcoal: textColors.charcoal,
  textDisabled: textColors.disabled,
  textPrimary: textColors.primary,
  textSecondary: textColors.secondary,
};

export function convertPxStringToNumber(pxString: string): number {
  return Number(pxString.replace('px', ''));
}

export function useModifiedStyleForWeb(style: XStyle | null | undefined): WebStyle | undefined {
  const { direction } = useTheme();
  if (isNil(style)) {
    return undefined;
  }
  return {
    ...style,
    left: direction === 'ltr' ? style.start : style.end,
    marginLeft: direction === 'ltr' ? style.marginStart : style.marginEnd,
    marginRight: direction === 'ltr' ? style.marginEnd : style.marginStart,
    paddingLeft: direction === 'ltr' ? style.paddingStart : style.paddingEnd,
    paddingRight: direction === 'ltr' ? style.paddingEnd : style.paddingStart,
    right: direction === 'ltr' ? style.end : style.start,
  };
}
